export default function FormDetails({request, setRequest}) {
    const handlePhoneChange = (e) => {
        let input = e.target.value;
        input = input.replace(/\D/g, '');
        if (input.length > 9) {
            input = input.slice(0, 9);
        }
        input = input.replace(/(\d{3})(?=\d)/g, '$1 ');
        setRequest(prev => ({ ...prev, phone: input }));
    };
    const handleReset = () => {
        setRequest({ phone: '', mail: '' });
    };
    return (
        <>
            <h1><span>Masz firmę?</span> Tankuj taniej!</h1>
            <h6>Wpisz swój numer telefonu lub adres mailowy, a wrócimy do Ciebie z ofertą.</h6>
            <label>
                <input
                    type="tel"
                    value={request.phone}
                    onChange={handlePhoneChange}
                    pattern="[0-9]{3} [0-9]{3} [0-9]{3}"
                    placeholder="757 813 148"
                    required={request.phone === '' && request.mail !== '' ? false : true}
                />
            </label>
            <h5>i / lub</h5>
            <label>
                <input
                    type="email"
                    value={request.mail}
                    onChange={e => setRequest(prev => ({ ...prev, mail: e.target.value }))}
                    placeholder="bh@azarex.pl"
                    required={request.phone !== '' && request.mail === '' ? false : true}
                />
            </label>
            <div className="formbuttons">
                <input type="button" value="Wyczyść" onClick={handleReset}/>
                <input type="submit" value="Wyślij"/>
            </div>
        </>
    )
}